import { PricingValueApiInterface } from '@/types/api-types';

import { SpotRateModel } from '../types';

export const getTotalRate = (rate?: SpotRateModel): PricingValueApiInterface => {
  if (!rate)
    return {
      value: 0,
      currency: 'USD',
    };

  const { pricing, toFees, fromFees } = rate;
  const toPrice = (toFees || []).reduce((accum, fee) => accum + (fee.cost.value || 0), 0);
  const fromPrice = (fromFees || []).reduce((accum, fee) => accum + (fee.cost.value || 0), 0);

  return {
    value: pricing.value + toPrice + fromPrice,
    currency: pricing.currency,
  };
};
